"use client";

import CTA from "@/components/Category/CTA";
import ToFAQ from "@/components/Category/ToFAQ";
import { site } from "@/data/default";
import { ReactNode } from "react";

const komputerTangerang: ReactNode = (
  <>
    <h2 className="text-xl font-bold mb-4">Kenapa Sewa Komputer di Tangerang Itu Strategis?</h2>
    <p className="mb-6 text-sm">
      Customer ada yang cerita, pernah pusing 7 keliling saat handle event pelatihan di kawasan industri Bitung, Tangerang. Komputer rusak, deadline mepet, beli unit baru jelas bukan solusi. Dari situ, kita sadar kalo "<strong>sewa komputer Tangerang</strong>" itu bukan sekadar alternatif, tapi strategi cerdas buat bisnis² yang butuh kecepatan, efisiensi, dan fleksibilitas tinggi.
    </p>

    <div className="space-y-6">
      <div className="bg-white rounded-2xl p-6 shadow border border-gray-100">
        <h3 className="font-semibold text-lg mb-2">Wilayah Layanan Komplit, dari Jatiuwung sampai Cikupa</h3>
        <p className="text-sm">
          Fokus kami pada area padat industri dan bisnis: Balaraja, Bitung, Jatiuwung, Karawaci, Pasar Kemis hingga Sepatan. Mau sewa komputer untuk kantor cabang, pelatihan massal, atau kebutuhan dadakan di <strong>Tangerang</strong>? Kami bisa kirim hari itu juga. Layanan <strong>sewa komputer Tangerang</strong> kami sudah terbukti cepat dan tanpa drama logistik.
        </p>
      </div>

      <div className="bg-white rounded-2xl p-6 shadow border border-gray-100">
        <h3 className="font-semibold text-lg mb-2">Spesifikasi Komputer Beragam: Office, Desain, sampai Workstation</h3>
        <p className="text-sm">
          Mau prosesor i5 generasi 10 untuk kerja ringan, atau butuh i9+GPU RTX buat kerja berat? Semua tersedia. Kami siapkan <strong>sewa komputer Tangerang</strong> sesuai request kamu. Tinggal kirimkan spek, kami siapkan dan antar.
        </p>
      </div>

      <div className="bg-white rounded-2xl p-6 shadow border border-gray-100">
        <h3 className="font-semibold text-lg mb-2">Harga Sewa Komputer Tangerang yang Bisa Nego</h3>
        <p className="text-sm">
          Kami ngerti tiap proyek beda kebutuhan. Makanya, kami sediakan opsi <strong>harga sewa komputer Tangerang</strong> mulai dari harian, mingguan, hingga bulanan. Mau sewa 3 unit, 30 unit, atau 300 unit? Harga tetap fleksibel dan bisa kamu sesuaikan. Tidak ada biaya tersembunyi.
        </p>
      </div>

      <div className="bg-white rounded-2xl p-6 shadow border border-gray-100">
        <h3 className="font-semibold text-lg mb-2">Gratis Ongkir Komputer ke Lokasi Bisnismu</h3>
        <p className="text-sm">
          Lokasi pengiriman kami mencakup banyak titik strategis di Tangerang: dari kawasan bisnis hingga area yang jauh dari pusat kota. Dengan <strong>sewa komputer Tangerang</strong>, kamu bisa hemat ongkir, hemat waktu, dan hemat tenaga.
        </p>
      </div>

      <div className="bg-white rounded-2xl p-6 shadow border border-gray-100">
        <h3 className="font-semibold text-lg mb-2">Support Teknisi 24/7 Selama Masa Sewa</h3>
        <p className="text-sm">
          Pernah tengah malam unit hang saat presentasi proyek tender? Percaya gak? Ada yang pernah loh. Tapi sejak pakai layanan <strong>sewa komputer Tangerang</strong> kami, semua kejadian itu cepat ditangani. Teknisi kami siaga 24/7. Problem cepat kelar, produktivitas tetap jalan.
        </p>
      </div>
    </div>

    <h2 className="text-xl font-bold mt-10 mb-4">Pilihan Durasi Sewa yang Super Fleksibel</h2>
    <p className="text-sm mb-6">
      Kamu bisa <strong>sewa komputer di Tangerang</strong> untuk 1 hari, 7 hari, atau 365 hari. Sesuaikan dengan kebutuhan. Cocok untuk operasional tambahan, seasonal project, sampai event tahunan. Fleksibilitas ini bikin kamu nggak harus overbudget beli unit.
    </p>

    <h2 className="text-xl font-bold mb-4">Komputer Langsung Pakai + Maintenance Rutin</h2>
    <p className="text-sm mb-6">
      Setiap unit <strong>komputer sewaan</strong> datang sudah pre-installed sesuai kebutuhanmu. Nggak perlu repot install ulang. Ditambah lagi, selama masa sewa kamu dapat full maintenance, penggantian unit kalau perlu, dan jaminan uptime tinggi.
    </p>

    <CTA
      title="Siap Kerja Tanpa Drama di Tangerang?"
      description="🚚 Cari <strong>sewa komputer Tangerang</strong> untuk kebutuhan kantoran, event, atau proyekmu?<br />Klik tombol di bawah ini dan tim kami siap bantu dari awal sampai akhir."
      buttonText="Booking Komputer Sekarang"
      onClick={() => {
        window.open(
          `https://wa.me/${site.whatsapp}?text=Halo%2C%20saya%20ingin%20booking%20komputer%20untuk%20Tangerang.%20Lokasi%20dan%20tanggal%20sudah%20siap.`,
          "_blank"
        );
      }}
    />

    <ToFAQ category="Komputer" />
  </>
);

export default komputerTangerang;